import { REDUCE_POLICY_HISTORY } from '../../constants/actions/policy';

export function reducePolicyHistory(payload) {
    return {
        type: REDUCE_POLICY_HISTORY,
        payload,
    };
}
